<script>
  // Breadcrumb trail. `items` is [{ label, href? }] — the last item is the current
  // page (rendered plain). Usually built by a page from its props.
  import { Link } from '@inertiajs/svelte'
  import Icon from './ui/icon.svelte'

  let { items = [] } = $props()
</script>

{#if items.length}
  <nav class="text-sm text-base-content/60 mb-2" aria-label="Breadcrumb">
    <ol class="flex items-center gap-1 flex-wrap">
      {#each items as item, i (item.label)}
        <li class="flex items-center gap-1">
          {#if item.href && i < items.length - 1}
            <Link href={item.href} class="link link-hover">{item.label}</Link>
          {:else}
            <span class="text-base-content/80">{item.label}</span>
          {/if}
          {#if i < items.length - 1}<Icon name="chevron_right" size="xs" class="text-base-content/30" />{/if}
        </li>
      {/each}
    </ol>
  </nav>
{/if}
